import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/banner/banner1.png'
import _imports_1 from '@/assets/imgs/banner2.png'
import _imports_2 from '@/assets/imgs/coop/icon_hr.png'
import _imports_3 from '@/assets/imgs/coop/icon_tx.png'
import _imports_4 from '@/assets/imgs/coop/icon_hw.png'
import _imports_5 from '@/assets/imgs/coop/icon_bd.png'
import _imports_6 from '@/assets/imgs/coop/icon_jrtt.png'
import _imports_7 from '@/assets/imgs/coop/icon_35.png'
import _imports_8 from '@/assets/imgs/coop/icon_xm.png'
import _imports_9 from '@/assets/imgs/coop/icon_yd.png'
import _imports_10 from '@/assets/imgs/coop/icon_360.png'
import _imports_11 from '@/assets/imgs/coop/icon_sina.png'
import _imports_12 from '@/assets/imgs/coop/icon_ylz.png'
import _imports_13 from '@/assets/imgs/coop/icon_fdgp.png'


const _withScopeId = n => (_pushScopeId("data-v-63d38452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "page-wrap page-search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "找项目、找合伙、找资金的资讯平台", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "conner-bg" }, null, -1))
const _hoisted_5 = { class: "section-wrap section-search" }
const _hoisted_6 = { class: "wrapper" }
const _hoisted_7 = { class: "subtab tab-1" }
const _hoisted_8 = { class: "tab" }
const _hoisted_9 = { class: "button-group" }
const _hoisted_10 = { class: "section-wrap section-enter" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = { class: "wrap" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-item current" }, [
  /*#__PURE__*/_createElementVNode("div", null, "我有活儿，找人才"),
  /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "百万人才，合作轻松愉快")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "我是人才，找活儿"),
  /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "每天大量项目入驻")
], -1))
const _hoisted_17 = { class: "content-item current" }
const _hoisted_18 = { class: "groups" }
const _hoisted_19 = { class: "group user" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物色人才，优质服务", -1))
const _hoisted_21 = { class: "tag" }
const _hoisted_22 = { class: "group publish" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发布需求,快速寻找伙伴", -1))
const _hoisted_24 = { class: "content-item" }
const _hoisted_25 = { class: "groups" }
const _hoisted_26 = { class: "group user" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "携手合作共创辉煌", -1))
const _hoisted_28 = { class: "tag" }
const _hoisted_29 = { class: "group publish" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发布需求,快速寻找伙伴", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "创业资讯", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-item current" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "wrap",
    title: "查看更多"
  }, "大学生创业")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "退伍军人创业")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "残疾人创业")
], -1))
const _hoisted_35 = { class: "content-item current" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20330", -1))
const _hoisted_37 = { class: "more" }
const _hoisted_38 = { class: "content-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20330", -1))
const _hoisted_40 = { class: "more" }
const _hoisted_41 = { class: "content-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20330", -1))
const _hoisted_43 = { class: "more" }
const _hoisted_44 = {
  class: "page-wrap page-wrap-gray",
  style: {"padding-top":"10px"}
}
const _hoisted_45 = { class: "section-wrap" }
const _hoisted_46 = { class: "section section-banner" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_48 = { class: "section section-big-block" }
const _hoisted_49 = { class: "section-block" }
const _hoisted_50 = { class: "section-content-wrap" }
const _hoisted_51 = { class: "list" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "找合伙", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "互联网一站式知识产权服务", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_55 = [
  _hoisted_52,
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"background":"#ffc611"}
}, "找资源", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "丰富的社区人脉群体", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_59 = [
  _hoisted_56,
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"background":"#87cb96"}
}, "找项目", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "高回报比的业务需求", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_63 = [
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"background":"#cede71"}
}, "找资金", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "丰厚的项目资金等您来拿", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_67 = [
  _hoisted_64,
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = { style: {"width":"100%"} }
const _hoisted_69 = { class: "page-wrap page-wrap-white" }
const _hoisted_70 = { class: "section-wrap" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "合伙路演", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 准备好迎接改变，共同见证科技与创新的完美结合，让我们在路演中探索未来的无限可能 ", -1))
const _hoisted_73 = { class: "section section-video-block" }
const _hoisted_74 = { class: "page-wrap" }
const _hoisted_75 = { class: "section-wrap" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "热门任务分享有D币", -1))
const _hoisted_77 = { class: "coin-task" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_79 = { class: "content" }
const _hoisted_80 = { class: "title" }
const _hoisted_81 = { class: "middle" }
const _hoisted_82 = { class: "price" }
const _hoisted_83 = {
  class: "desc",
  style: {"font-size":"16px","margin-top":"5px","text-align":"right"}
}
const _hoisted_84 = { class: "page-wrap page-wrap-gray" }
const _hoisted_85 = { class: "section-wrap" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "在线赋能工具", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 通过在线赋能，释放您的潜力，提升您的竞争力，让成功触手可及 ", -1))
const _hoisted_88 = { class: "section section-big-block section-mix-block" }
const _hoisted_89 = { class: "section-block" }
const _hoisted_90 = { class: "section-content-wrap" }
const _hoisted_91 = { class: "list" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "月光宝盒", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "互联网资源大全", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_95 = [
  _hoisted_92,
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"background":"#ffc611"}
}, "华山论剑", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "最新赛事", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_99 = [
  _hoisted_96,
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"background":"#87cb96"}
}, "吐槽", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "闲聊一下", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_103 = [
  _hoisted_100,
  _hoisted_101,
  _hoisted_102
]
const _hoisted_104 = { class: "content-item" }
const _hoisted_105 = { class: "content-item" }
const _hoisted_106 = { class: "content-item current-item-tc" }
const _hoisted_107 = /*#__PURE__*/_createStaticVNode("<div class=\"page-wrap\" data-v-63d38452><div class=\"section-wrap\" data-v-63d38452><h2 data-v-63d38452>来自全球客户的信任和选择</h2><div class=\"tip\" data-v-63d38452>专业高效服务全球海量客户，连续12年为用户创造价值</div><div class=\"coop-items\" data-v-63d38452><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_2 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_3 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_4 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_5 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_6 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_7 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_8 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_9 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_10 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_11 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_12 + "\" data-v-63d38452></a><a href=\"javascript:void(null)\" data-v-63d38452><img src=\"" + _imports_13 + "\" data-v-63d38452></a></div></div></div>", 1)

import {
  ref,
  reactive,
  defineAsyncComponent,
  onMounted,
  getCurrentInstance,
} from 'vue'
import { useRouter } from 'vue-router'
import qs from 'qs'
import { Options, Vue } from 'vue-class-component'
import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src
import ItemProject from '@/components/ItemProject.vue'
import ItemProjectCoop from '@/components/ItemProjectCoop.vue'
import ItemProjectFund from '@/components/ItemProjectFund.vue'
import ItemWXGroup from '@/components/ItemWXGroup.vue'

import ItemProjectVideo from '@/components/ItemProjectVideo.vue'
import SimpleTab from '@/components/SimpleTab.vue'
import AppComponent from '@/components/AppComponent.vue'
import Helper from '@/components/Helper.vue'

import { showRoast } from '@/libs/comp'
import { Api } from '@/services/http'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const router = useRouter()
const searchTab = ref(0)
const searchEle = ref(null)
const selectInfoItem = ref(0)
const selectMixInfoItem = ref(0)
const projectType = ref('coop')
const instance = getCurrentInstance()
const dialogRef = ref(null)

const pageData = reactive({
  // 焦点图数据
  arousel: [],
  //合伙路演
  partnership: [],
  //
  starTasks: [],

  //项目，合伙，资金，资源
  project: [],
  coop: [],
  fund: [],
  resource: [],
})

// 新闻数据
const news: any = reactive({
  '1': [], //大学生
  '2': [], //退伍军人
  '3': [], //大健康
})

const updateCurrentSearchTab = (index: number) => {
  searchTab.value = index
}
const isCurrentInfoSelected = (index: number) => {
  return selectInfoItem.value == index
}
const isCurrentMixInfoSelected = (index: number) => {
  return selectMixInfoItem.value == index
}
const onHoverInfoItem = (index: number) => {
  selectInfoItem.value = index
}
const onHoverMixInfoItem = (index: number) => {
  if (index == 1) {
    loadComponent('hs')
  } else if (index == 2) {
    loadComponent('tc')
  }
  selectMixInfoItem.value = index
}

const asyncComponents: any = reactive({
  // 华山
  hs: null,
  // 吐槽
  tc: null,
})

const loadComponent = (name: 'hs' | 'tc') => {
  if (!asyncComponents[name]) {
    if (name == 'hs') {
      asyncComponents[name] = defineAsyncComponent(
        () => import('@/components/MatchComponent.vue')
      )
    } else if (name == 'tc') {
      asyncComponents[name] = defineAsyncComponent(
        () => import('@/components/RoastComponentList.vue')
      )
    }
  }
}

const handleSearch = () => {
  const value = searchEle.value.value
  if (value) {
    const paths = ['/resource', '/coop', '/project', '/fund']
    const findPath = paths[searchTab.value]
    router.push({ path: findPath, query: { keyword: value } })
  }
}
const handleKeySearch = e => {
  if (e.keyCode == 13) {
    handleSearch()
  }
}
const handleRoast = () => {
  const { proxy, ctx } = instance
  showRoast(proxy, dialogRef)
}
const mounted = async () => {
  //news
  for (let i = 0; i < 3; i++) {
    const api = `/client-api/news/list`
    const payload = {
      groupOriented: i + 1,
      current: 1,
      size: 15,
    }
    const data: any[] = (await Api.post(api, qs.stringify(payload))).list
    news[i + 1] = data.slice(0, 4)
  }
  //焦点图
  const adData = await Api.get(`/client-api/index/adList`)

  pageData.arousel = adData.projectAdList.map(item => {
    return {
      ...item,
      src: item.coverImage,
    }
  })
  // 合伙路演
  pageData.partnership = adData.partnershipAdList
  const len = 10 - pageData.partnership.length
  // 合伙补数据
  const partnership = await Api.post(
    `/client-api/partnership/list`,
    qs.stringify({
      size: 100,
    })
  )
  let fixed = []
  if (partnership.list.length <= 30) {
    fixed = partnership.list.slice(0, len)
  } else {
    for (let i = 0; i < len; i++) {
      // 随机取
      fixed.push(
        partnership.list[Math.floor(Math.random() * partnership.list.length)]
      )
    }
  }
  pageData.partnership = pageData.partnership.concat(fixed)
  // 星级任务
  pageData.starTasks = await Api.get(`/client-api/starTask/taskList`)
  // 项目，合伙，资金，资源
  pageData.coop = (await Api.post(`/client-api/partnership/list`, '')).list
  pageData.fund = (await Api.post(`/client-api/funder/list`, '')).list
  pageData.project = (
    await Api.post(`/client-api/project/list`, 'size=12')
  ).list
  pageData.resource = (
    await Api.post(`/client-api/resourceGroup/list`, '')
  ).list
  console.log('页数据', pageData)
}
onMounted(() => {
  mounted()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Helper),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  current: searchTab.value == 0,
                }),
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => (updateCurrentSearchTab(0)))
              }, " 资源 ", 34),
              _createElementVNode("li", {
                class: _normalizeClass({
                  current: searchTab.value == 1,
                }),
                onMouseover: _cache[1] || (_cache[1] = ($event: any) => (updateCurrentSearchTab(1)))
              }, " 合伙 ", 34),
              _createElementVNode("li", {
                class: _normalizeClass({
                  current: searchTab.value == 2,
                }),
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => (updateCurrentSearchTab(2)))
              }, " 项目 ", 34),
              _createElementVNode("li", {
                class: _normalizeClass({
                  current: searchTab.value == 3,
                }),
                onMouseover: _cache[3] || (_cache[3] = ($event: any) => (updateCurrentSearchTab(3)))
              }, " 资金 ", 34)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              type: "text",
              placeholder: "请输入资源、合伙、项目的关键词",
              ref_key: "searchEle",
              ref: searchEle,
              onKeyup: handleKeySearch
            }, null, 544),
            _createElementVNode("div", {
              class: "button",
              onClick: handleSearch
            }, "搜索")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_carousel, { height: "420px" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.arousel, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        to: `/project/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.src
                          }, null, 8, _hoisted_13)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(SimpleTab, { class: "simple-tab-enter" }, {
            tabs: _withCtx(() => [
              _hoisted_15,
              _hoisted_16
            ]),
            contents: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_svg_icon, { icon: "icon_users" }),
                    _hoisted_20,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: "/member",
                          class: "more"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("全部")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=设计师" }, {
                          default: _withCtx(() => [
                            _createTextVNode("设计师")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=研发" }, {
                          default: _withCtx(() => [
                            _createTextVNode("研发")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=视频" }, {
                          default: _withCtx(() => [
                            _createTextVNode("视频")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=文案" }, {
                          default: _withCtx(() => [
                            _createTextVNode("文案")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=装修" }, {
                          default: _withCtx(() => [
                            _createTextVNode("装修")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=营销" }, {
                          default: _withCtx(() => [
                            _createTextVNode("营销")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/member?tag=企业服务" }, {
                          default: _withCtx(() => [
                            _createTextVNode("企业服务")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_svg_icon, { icon: "icon_publish" }),
                    _hoisted_23,
                    _createVNode(_component_router_link, {
                      to: "/publish/project?type=task",
                      class: "button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("发布需求")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_svg_icon, { icon: "icon_p_coop" }),
                    _hoisted_27,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: "/member",
                          class: "more"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("全部")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=设计师" }, {
                          default: _withCtx(() => [
                            _createTextVNode("设计师")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=研发" }, {
                          default: _withCtx(() => [
                            _createTextVNode("研发")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=视频" }, {
                          default: _withCtx(() => [
                            _createTextVNode("视频")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=文案" }, {
                          default: _withCtx(() => [
                            _createTextVNode("文案")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=装修" }, {
                          default: _withCtx(() => [
                            _createTextVNode("装修")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=营销" }, {
                          default: _withCtx(() => [
                            _createTextVNode("营销")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, { to: "/work?tag=企业服务" }, {
                          default: _withCtx(() => [
                            _createTextVNode("企业服务")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_svg_icon, { icon: "icon_publish" }),
                    _hoisted_30,
                    _createVNode(_component_router_link, {
                      to: "/publish/project?type=task",
                      class: "button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("发布需求")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _hoisted_31,
            _createVNode(SimpleTab, { class: "tab-news" }, {
              tabs: _withCtx(() => [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34
              ]),
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news['1'], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/news/${item.id}`,
                        target: "_blank",
                        title: item.title
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("・" + _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]),
                      _hoisted_36
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_router_link, { to: "/news?type=student" }, {
                      default: _withCtx(() => [
                        _createTextVNode("更多资讯 >>")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news['2'], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/news/${item.id}`,
                        target: "_blank",
                        title: item.title
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("・" + _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]),
                      _hoisted_39
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_router_link, { to: "/news?type=soldier" }, {
                      default: _withCtx(() => [
                        _createTextVNode("更多资讯 >>")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news['3'], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/news/${item.id}`,
                        target: "_blank",
                        title: item.title
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("・" + _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]),
                      _hoisted_42
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_router_link, { to: "/news?type=sick" }, {
                      default: _withCtx(() => [
                        _createTextVNode("更多资讯 >>")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_router_link, {
            to: "/game",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", {
                  class: _normalizeClass({
                    info: true,
                    'info-current': isCurrentInfoSelected(0),
                  }),
                  onMouseover: _cache[4] || (_cache[4] = ($event: any) => (onHoverInfoItem(0)))
                }, _hoisted_55, 34),
                _createElementVNode("div", {
                  class: _normalizeClass({
                    info: true,
                    'info-current': isCurrentInfoSelected(1),
                  }),
                  onMouseover: _cache[5] || (_cache[5] = ($event: any) => (onHoverInfoItem(1)))
                }, _hoisted_59, 34),
                _createElementVNode("div", {
                  class: _normalizeClass(["info", {
                    info: true,
                    'info-current': isCurrentInfoSelected(2),
                  }]),
                  onMouseover: _cache[6] || (_cache[6] = ($event: any) => (onHoverInfoItem(2)))
                }, _hoisted_63, 34),
                _createElementVNode("div", {
                  class: _normalizeClass(["info", {
                    info: true,
                    'info-current': isCurrentInfoSelected(3),
                  }]),
                  onMouseover: _cache[7] || (_cache[7] = ($event: any) => (onHoverInfoItem(3)))
                }, _hoisted_67, 34)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", {
                  class: _normalizeClass(`content ${
                    isCurrentInfoSelected(0) ? 'content-current' : ''
                  }`)
                }, [
                  _createVNode(_component_router_link, {
                    to: "/coop",
                    class: "block-more"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更多..")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.coop, (item) => {
                    return (_openBlock(), _createBlock(ItemProjectCoop, {
                      class: "item",
                      key: item.id,
                      data: item
                    }, null, 8, ["data"]))
                  }), 128))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`content ${
                    isCurrentInfoSelected(1) ? 'content-current' : ''
                  }`)
                }, [
                  _createVNode(_component_router_link, {
                    to: "/resource",
                    class: "block-more"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更多..")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.resource, (item) => {
                    return (_openBlock(), _createBlock(ItemWXGroup, {
                      class: "item",
                      key: item.id,
                      data: item
                    }, null, 8, ["data"]))
                  }), 128))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`content ${
                    isCurrentInfoSelected(2) ? 'content-current' : ''
                  }`)
                }, [
                  _createVNode(_component_router_link, {
                    to: "/project",
                    class: "block-more"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更多..")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.project, (item) => {
                    return (_openBlock(), _createBlock(ItemProject, {
                      class: "item",
                      key: item.id,
                      data: item
                    }, null, 8, ["data"]))
                  }), 128))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`content ${
                    isCurrentInfoSelected(3) ? 'content-current' : ''
                  }`)
                }, [
                  _createVNode(_component_router_link, {
                    to: "/fund",
                    class: "block-more"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更多..")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.fund, (item) => {
                    return (_openBlock(), _createBlock(ItemProjectFund, {
                      class: "item",
                      key: item.id,
                      data: item
                    }, null, 8, ["data"]))
                  }), 128))
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _hoisted_71,
        _hoisted_72,
        _createElementVNode("div", _hoisted_73, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.partnership, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item-wrap",
              key: item.id
            }, [
              _createVNode(ItemProjectVideo, {
                class: "item",
                data: item
              }, null, 8, ["data"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_74, [
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _createElementVNode("div", _hoisted_77, [
          _hoisted_78,
          _createElementVNode("div", _hoisted_79, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.starTasks, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_80, _toDisplayString(item.taskName), 1),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("span", _hoisted_82, _toDisplayString(item.rewardAmount) + " D币", 1),
                  _createElementVNode("em", {
                    class: _normalizeClass(`tag tag-${item.taskType}`)
                  }, _toDisplayString(item.taskType == 3
                      ? '已作废'
                      : item.taskType == 2
                      ? '成功完成'
                      : '已领取'), 3)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_router_link, { to: `` }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看详情")
                    ]),
                    _: 1
                  })
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_84, [
      _createElementVNode("div", _hoisted_85, [
        _hoisted_86,
        _hoisted_87,
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", {
                  class: _normalizeClass({
                    info: true,
                    'info-current': isCurrentMixInfoSelected(0),
                  }),
                  onMouseover: _cache[8] || (_cache[8] = ($event: any) => (onHoverMixInfoItem(0)))
                }, _hoisted_95, 34),
                _createElementVNode("div", {
                  class: _normalizeClass({
                    info: true,
                    'info-current': isCurrentMixInfoSelected(1),
                  }),
                  onMouseover: _cache[9] || (_cache[9] = ($event: any) => (onHoverMixInfoItem(1)))
                }, _hoisted_99, 34),
                _createElementVNode("div", {
                  class: _normalizeClass(["info", {
                    info: true,
                    'info-current': isCurrentMixInfoSelected(2),
                  }]),
                  onMouseover: _cache[10] || (_cache[10] = ($event: any) => (onHoverMixInfoItem(2)))
                }, _hoisted_103, 34)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_104, [
                _createVNode(AppComponent)
              ], 512), [
                [_vShow, isCurrentMixInfoSelected(0)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_105, [
                (asyncComponents['hs'])
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(asyncComponents['hs']), { key: 0 }))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, isCurrentMixInfoSelected(1)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_106, [
                (asyncComponents['tc'])
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(asyncComponents['tc']), { key: 0 }))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, isCurrentMixInfoSelected(2)]
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_107
  ]))
}
}

})